function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  position: relative;\n  cursor: pointer;\n\n  &:after {\n    border: 1px solid #46494c;\n    border-left: 4px solid transparent !important;\n    border-right: 4px solid transparent !important;\n    border-top: 5px solid #797e83 !important;\n    border-bottom: none !important;\n    transform: none !important;\n    content: ' ';\n    display: block;\n    pointer-events: none;\n    position: absolute;\n    transform: rotate(-45deg);\n    z-index: 1;\n    top: 47%;\n    ",
        "\n    ",
        "\n  }\n\n  &.--overflow {\n    &:before {\n      content: '...';\n      position: absolute;\n      top: 29%;\n      right: 26px;\n      width: 22px;\n      z-index: 2;\n      background-color: white;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  appearance: none;\n  background-color: ",
        ";\n  border: ",
        ";\n  border-color: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: none;\n  color: #6d747b;\n  cursor: ",
        ";\n  display: block;\n  font-size: 13px;\n  height: 45px;\n  min-width: 50px;\n  outline: none;\n  padding: 2px 31px 0px 12px;\n  position: relative;\n  width: 100%;\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  &:active,\n  &:focus {\n    border: ",
        ";\n    box-shadow: none;\n  }\n\n  &:hover {\n    border: ",
        ";\n  }\n\n  &[disabled] {\n    background-color: #ecf0f3;\n    color: #7a7a7a;\n    border-color: whitesmoke;\n    opacity: unset;\n  }\n\n  /* remove outline on FF */\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #6d747b;\n  }\n  option:not(:checked) {\n    color: #707478;\n  }\n\n  @media ",
        " {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { space, height, color, top, width as styledWidth, right as styledRight, display as styledDisplay, fontSize as styledFontSize, borderRadius } from 'styled-system';
import styled from 'styled-components';
import { mediaQueries } from 'shared/styles';
export var SelectContainer = styled.span(_templateObject(), styledWidth, color, styledDisplay, space, styledRight, top);
export var StyledSelect = styled.select(_templateObject1(), function(props) {
    return props.backgroundColor || 'transparent';
}, function(props) {
    return props.border || '1px solid transparent';
}, function(props) {
    return props.error ? '#e25241 !important' : '#d1d5da';
}, function(param) {
    var theme = param.theme;
    var _theme_customized_radius, _theme_customized;
    var _theme_customized_radius_sm;
    return (_theme_customized_radius_sm = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_radius = _theme_customized.radius) === null || _theme_customized_radius === void 0 ? void 0 : _theme_customized_radius.sm) !== null && _theme_customized_radius_sm !== void 0 ? _theme_customized_radius_sm : '3px';
}, function(props) {
    return props.disabled ? 'not-allowed' : 'pointer';
}, space, height, styledFontSize, borderRadius, function(props) {
    return props.border || '1px solid #dbdbdb';
}, function(props) {
    return props.border || '1px solid #b6b6b6';
}, mediaQueries.largePhone);
var Select = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var width = _param.width, _param_bg = _param.bg, bg = _param_bg === void 0 ? '#fcfdfe' : _param_bg, _param_right = _param.right, right = _param_right === void 0 ? '18px' : _param_right, _param_display = _param.display, display = _param_display === void 0 ? [
        'block'
    ] : _param_display, _param_fontSize = _param.fontSize, fontSize = _param_fontSize === void 0 ? [
        '16px',
        '16px',
        '16px',
        '13px'
    ] : _param_fontSize, carrotTop = _param.carrotTop, className = _param.className, mt = _param.mt, pr = _param.pr, props = _object_without_properties(_param, [
        "width",
        "bg",
        "right",
        "display",
        "fontSize",
        "carrotTop",
        "className",
        "mt",
        "pr"
    ]);
    return /*#__PURE__*/ _jsx(SelectContainer, {
        bg: bg,
        className: className,
        display: display,
        mt: mt,
        right: right,
        top: carrotTop,
        width: width,
        pr: pr,
        children: /*#__PURE__*/ _jsx(StyledSelect, _object_spread({
            ref: ref,
            fontSize: fontSize
        }, props))
    });
});
export default Select;
